/* Editorial by LA REAL — orden de la colección (navega con ?sort_by=) */
(function(){
  document.addEventListener('change',function(e){
    var sel=e.target.closest('[data-sort-by]'); if(!sel) return;
    var p=new URLSearchParams(location.search); p.set('sort_by',sel.value); p.delete('page');
    location.search=p.toString();
  });
})();
